import React from 'react';
import AboutSection from '../../components/about/AboutSection';

const About = () => {
  return (
    <div className="about-page" style={{ paddingTop: '80px', minHeight: '100vh', backgroundColor: 'var(--bg-color)' }}>
      <AboutSection />
    </div>
  );
};

export default About;
